import type {
  BulkTagRequest,
  ClientTagFilter,
  ClientTagRequest,
  ClientTagResponse,
  ClientTagUpdateRequest,
  ClientTagWithItems,
  TargetTag,
  TargetTagUpdateRequest,
} from '@pbk-web/types';

import type { ApiResponse } from '../models/ApiResponse';
import BaseService from './BaseService';

export default class ClientTagService extends BaseService {
  public static getAllTags(clientId: string, filters: ClientTagFilter): Promise<ApiResponse<ClientTagResponse[]>> {
    return this.get(`/v1/clients/${clientId}/tags`, { params: filters });
  }

  public static getTag<TItem = unknown>(clientId: string, tagId: string): Promise<ApiResponse<ClientTagWithItems<TItem>>> {
    return this.get(`/v1/clients/${clientId}/tags/${tagId}`);
  }

  public static updateTag(clientId: string, tagId: string, tag: ClientTagUpdateRequest): Promise<ApiResponse<ClientTagResponse>> {
    return this.put(`/v1/clients/${clientId}/tags/${tagId}`, tag);
  }

  public static deleteTag(clientId: string, tagId: string, keepGroupAssignments?: boolean): Promise<ApiResponse<void>> {
    return this.delete(`/v1/clients/${clientId}/tags/${tagId}`, { params: { keepGroupAssignments } });
  }

  public static createTag(clientId: string, tag: ClientTagRequest): Promise<ApiResponse<ClientTagResponse>> {
    return this.post(`/v1/clients/${clientId}/tags`, tag);
  }

  public static linkTag(clientId: string, tagId: string, targetId: string): Promise<ApiResponse<void>> {
    return this.post(`/v1/clients/${clientId}/tags/${tagId}/link/${targetId}`);
  }

  public static unlinkTag(clientId: string, tagId: string, targetId: string): Promise<ApiResponse<void>> {
    return this.delete(`/v1/clients/${clientId}/tags/${tagId}/link/${targetId}`);
  }

  public static bulkTag(clientId: string, tagId: string, payload: BulkTagRequest): Promise<ApiResponse<void>> {
    return this.post(`/v1/clients/${clientId}/tags/${tagId}/link/bulk`, payload);
  }

  public static getTargetTags(clientId: string, targetId: string, type: number): Promise<ApiResponse<TargetTag[]>> {
    return this.get(`/v1/clients/${clientId}/tags/targets/${targetId}`, { params: { type } });
  }

  public static updateTargetTags(clientId: string, targetId: string, payload: TargetTagUpdateRequest): Promise<ApiResponse<boolean>> {
    return this.put(`/v1/clients/${clientId}/tags/targets/${targetId}`, payload);
  }
}
